/* global axios */
import ApiClient from '../ApiClient';

class ArrowsAiCustomToolsAPI extends ApiClient {
  constructor() {
    super('arrows_ai/assistants', { accountScoped: true });
  }

  get({ assistantId } = {}) {
    return axios.get(`${this.url}/${assistantId}/custom_tools`);
  }

  create({ assistantId, payload } = {}) {
    return axios.post(`${this.url}/${assistantId}/custom_tools`, {
      custom_tool: payload,
    });
  }

  update({ assistantId, id, payload } = {}) {
    return axios.patch(`${this.url}/${assistantId}/custom_tools/${id}`, {
      custom_tool: payload,
    });
  }

  delete({ assistantId, id } = {}) {
    return axios.delete(`${this.url}/${assistantId}/custom_tools/${id}`);
  }

  test({ assistantId, payload } = {}) {
    return axios.post(`${this.url}/${assistantId}/custom_tools/test`, {
      custom_tool: payload,
    });
  }
}

export default new ArrowsAiCustomToolsAPI();
